import { defineComponent as _defineComponent } from 'vue'
import { reactive, computed, ref, onMounted } from "vue";
  import useVuelidate from "@vuelidate/core";
  import { required, numeric } from "@vuelidate/validators";
  import store from "@/store";
  import router from "@/router";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import { LotStatus } from "@/enums/LotStatus";
  import { OfflinePhases } from "@/enums/OfflinePhase";
  import ToggleButton from "@/components/ui/ToggleButton.vue";
  import SelectBuildersLotModal from "@/components/ui/modals/SelectBuildersLotModal.vue";
  import { BuilderInterface } from "@/types/BuilderInterface";
  import { useToast } from "vue-toastification";
  import {
    formatPriceTrim,
    updatePriceInput,
  } from "@/helpers/transformation/price";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminLotCreate',
  setup(__props, { expose: __expose }) {
  __expose();

  const toast = useToast();

  const builders = ref<BuilderInterface[]>([]);
  const isSelectBuildersModalOpen = ref(false);

  const userId = router.currentRoute.value.params.userId;
  const estateId = router.currentRoute.value.params.estateId;
  const stageId = router.currentRoute.value.params.stageId;
  const form = reactive({
    title: "",
    blockWidth: null,
    blockDepth: null,
    size: 0,
    price: 0,
    status: LotStatus.NOT_RELEASED,
    landownerId: userId,
    estateId: estateId,
    stageId: stageId,
    isBuildersEnabled: false,
    builders: [],
    streetName: "",
  });
  const rules = computed(() => {
    return {
      title: { required, $autoDirty: true },
      blockWidth: { numeric, $autoDirty: true },
      blockDepth: { numeric, $autoDirty: true },
      size: { required, numeric, $autoDirty: true },
      price: { required, numeric, $autoDirty: true },
    };
  });
  const v$ = useVuelidate(rules, form);
  const lotStatuses = [
    LotStatus.NOT_RELEASED,
    LotStatus.SETTLED,
    LotStatus.OFFLINE,
  ];

  async function createLot() {
    v$.value.$touch();
    const isFormCorrect = await v$.value.$validate();

    if (form.isBuildersEnabled && !form.builders.length) {
      toast.error(
        "Please, if the home & land package is enabled, add at least one builder."
      );
      return;
    }

    if (!isFormCorrect) return;

    if (!form.blockWidth) {
      form.blockWidth = null;
    }

    if (!form.blockDepth) {
      form.blockDepth = null;
    }

    if (form.status === LotStatus.OFFLINE) {
      form.offlineSale = {
        offlineBuyerData: {
          fullName: "",
        },
        salePhase: OfflinePhases.EOI,
      };
    }

    store.dispatch("lot/createLot", form).then(() => {
      router.push({
        name: "AdminStage",
        params: { userId, estateId, stageId },
      });
    });
  }
  const getBuilders = async () => {
    const { data } = await store.dispatch("builder/getAllBuilderWithHouses");

    builders.value = data;
  };

  function changeStatus(status: LotStatus) {
    form.status = status;
  }

  onMounted(() => {
    getBuilders();
  });

const __returned__ = { toast, builders, isSelectBuildersModalOpen, userId, estateId, stageId, form, rules, v$, lotStatuses, createLot, getBuilders, changeStatus, reactive, computed, ref, onMounted, get useVuelidate() { return useVuelidate }, get required() { return required }, get numeric() { return numeric }, get store() { return store }, get router() { return router }, DropDown, get LotStatus() { return LotStatus }, get OfflinePhases() { return OfflinePhases }, ToggleButton, SelectBuildersLotModal, get BuilderInterface() { return BuilderInterface }, get useToast() { return useToast }, get formatPriceTrim() { return formatPriceTrim }, get updatePriceInput() { return updatePriceInput } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})